import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, skip, tap } from 'rxjs/operators';

interface IData{
  isUnknown:boolean;
  comment:string|null;
}

const heightAnimation = trigger('heightAnimation', [
  state('void', style({ height: '0' })),
  transition(':enter', [
    animate('0.3s ease-in-out', style({ height: '*' }))
  ]),
  transition(':leave', [
    animate('0.3s ease-in-out', style({ height: '0' }))
  ])
])

const sendButtonAnimation = trigger('sendButtonAnimation', [
  state('void', style({ opacity: '0' })),
  transition(':enter', [
    animate('0.5s 0.15s ease-in-out', style({ opacity: '1' }))
  ])
])

@Component({
  selector: 'app-expand-sec',
  templateUrl: './expand-sec.component.html',
  styleUrls: ['./expand-sec.component.scss'],
  animations: [
    heightAnimation,
    sendButtonAnimation,
  ]
})
export class ExpandSecComponent implements OnInit {
  @Input()config:{isShowUnknown: boolean; isShowComment: boolean; questionId: number, isUnknownInitalValue: boolean|null} = <{isShowUnknown: boolean; isShowComment: boolean; questionId: number, isUnknownInitalValue: boolean|null}>{};
  @Input()showFormObs:Observable<boolean> = new Observable<boolean>
  @Output()dataEmitter:EventEmitter<IData> = new EventEmitter<IData>()
  @Output()commentEmitter:EventEmitter<null> = new EventEmitter<null>()
  sendEmptyComment:boolean = false;
  formGroup = new UntypedFormGroup({
    isUnknown: new UntypedFormControl(false),
    comment: new UntypedFormControl('')
  })
  constructor() { }

  ngOnInit(): void {
    this.emitDataObs().subscribe()
    setTimeout(() => {
      if(this.config.isUnknownInitalValue)
        this.formGroup.controls['isUnknown'].setValue(this.config.isUnknownInitalValue)
    });
    this.formGroup.controls['isUnknown'].valueChanges.pipe(
      skip(1),
      distinctUntilChanged(),
      debounceTime(300),
    ).subscribe(
      (data:boolean)=>{
        // if(data)
        //   this.quizVagueQuestionsManagement.increaseVagueQuestion()
        // else
        //   this.quizVagueQuestionsManagement.reduceVagueQuestion()
      }
    )
    this.formGroup.controls['isUnknown']
  }
  emitDataObs():Observable<IData>{
    return this.formGroup.valueChanges.pipe(
      distinctUntilChanged(),
      debounceTime(300),
      tap(data=>this.emitData(data)),
    )
  }
  emitData(data:IData){
    this.dataEmitter.emit(data)
  }
  submitComment(){
    let comment = this.formGroup.controls['comment'].value
    if(comment == '' || comment == null || comment == undefined){
      this.sendEmptyComment = true;
      setTimeout(() => {
        this.sendEmptyComment = false;
      }, 350);
    }else{
      this.commentEmitter.emit()
      this.formGroup.controls['comment'].reset()
    }
  }
}
